module.exports = __webpack_public_path__ + "static/salon-pasajeros---iluminacion-ebd1c1771100396eaba3247949f26cd1.jpg";